import { Layout, Step, Stepper, } from "@mcleod/components";

export abstract class AutogenLayoutMultiSendRateConfirmation extends Layout {

}
